import { render } from "./UserModal.vue?vue&type=template&id=13e575cf&scoped=true&ts=true"
import script from "./UserModal.vue?vue&type=script&lang=ts"
export * from "./UserModal.vue?vue&type=script&lang=ts"

import "./UserModal.vue?vue&type=style&index=0&id=13e575cf&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e575cf"]])

export default __exports__